const config = {
  emulator: {
    enable: !!process.env.VUE_APP_FIRESTORE_EMULATOR_HOST,
    host: process.env.VUE_APP_FIRESTORE_EMULATOR_HOST
  },
  app: {
    name: parse(process.env.VUE_APP_NAME, "TEST Close Dirt"),
    version: parse(process.env.PACKAGE_VERSION, "0.0.0"),
  },
  maps: {
    api_key: parse(process.env.VUE_APP_MAPS_API_KEY, 'AIzaSyD4GxKGXUyHOK6Tzljjy4bjExFk6Wfa12I'),
  },
  firebase: {
    projectId: parse(process.env.VUE_APP_FIREBASE_projectId, "close-dirt-test"),
    appId: parse(process.env.VUE_APP_FIREBASE_appId, "1:744870969784:web:0f4cabb91bbaf4c9298f4d"),
    locationId: "us-central",
    apiKey: parse(process.env.VUE_APP_FIREBASE_apiKey, "AIzaSyDOUVTgHJZM42AGXHWMJEnbdyPKM8yBmdE"),
    messagingSenderId: parse(process.env.VUE_APP_FIREBASE_messagingSenderId, "744870969784"),
    measurementId: parse(process.env.VUE_APP_FIREBASE_measurementId, "G-5NZG7X98D6"),
  }
}

config.firebase.databaseURL = `https://${config.firebase.projectId}.firebaseio.com`;
config.firebase.storageBucket = `${config.firebase.projectId}.appspot.com`;
config.firebase.authDomain = `${config.firebase.projectId}.firebaseapp.com`;

function parse (value, fallback) {
  if (typeof value === 'undefined') {
    return fallback
  }

  switch (typeof fallback) {
    case 'boolean' :
      return !!JSON.parse(value)
    case 'number' :
      return JSON.parse(value)
    default :
      return value
  }
}

export {
  config
}

export default {
  install (Vue) {
    Vue.appConfig = config
    Vue.prototype.$appConfig = config
 }
}